module.exports = __webpack_public_path__ + "img/no_trips.9765915e.png";